/**
 * Keeps the Goddess Circle member price in sync with the selected variant.
 *
 * Listens for the Horizon `variant:update` event (dispatched by variant-picker.js)
 * on the closest `.shopify-section`. When the variant changes, the event carries
 * server-rendered HTML for the new variant. We find the updated member price in
 * that HTML by matching `data-block-id` and swap the price value in place.
 *
 * Mirrors the pattern used by `product-price.js` / `ProductPrice` custom element.
 */

function initGoddessPrice() {
  document.querySelectorAll('.awe-goddess-member-container[data-block-id]').forEach((container) => {
    const section = container.closest('.shopify-section, dialog');
    if (!section) return;

    section.addEventListener('variant:update', (event) => {
      const blockId = container.dataset.blockId;

      // Guard: ignore events from a different product (combined listings)
      if (
        !event.detail?.data?.newProduct &&
        event.target instanceof HTMLElement &&
        event.target.dataset.productId !== undefined
      ) {
        const productPrice = section.querySelector(`product-price[data-block-id]`);
        if (productPrice && event.target.dataset.productId !== productPrice.dataset.productId) {
          return;
        }
      }

      const newContainer = event.detail?.data?.html?.querySelector(
        `.awe-goddess-member-container[data-block-id="${blockId}"]`
      );
      if (!newContainer) return;

      const currentPrice = container.querySelector('[data-member-price-value]');
      const newPrice = newContainer.querySelector('[data-member-price-value]');
      if (currentPrice && newPrice) {
        currentPrice.textContent = newPrice.textContent;
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGoddessPrice);
} else {
  initGoddessPrice();
}
